import type { ValueLists } from '@ohpen/enso-ui';
import { FieldType, FirmGetAllResponse } from '@pmp/api';

export const EXCLUSIVE_SETS_ENTITY_LIST_NAMES: FieldType[] = [FieldType.FIRMS, FieldType.PRINCIPALS];

export const EXCLUSIVITY_SETS_VALUE_LIST_NAMES: FieldType[] = [FieldType.FIRMS];

export const buildPrincipalIdToFirmIds = (
  valueLists?: ValueLists,
  firms?: FirmGetAllResponse[],
): Record<string, string[]> => {
  const principals = valueLists?.[FieldType.PRINCIPALS];
  if (!principals || !firms?.length) return {};
  const nameToPrincipalId: Record<string, string> = Object.fromEntries(
    Object.entries(principals).map(([id, name]) => [name, id]),
  );
  return firms.reduce<Record<string, string[]>>((acc, firm) => {
    const principalId = nameToPrincipalId[firm.principalFirm?.name ?? ''];
    if (!principalId) return acc;
    if (!acc[principalId]) acc[principalId] = [];
    acc[principalId].push(firm.id);
    return acc;
  }, {});
};
